(function($) {
    'use strict';
    return;

    // Kolla om vi är på /kampanjer/julbord/
    if (window.location.pathname === '/kampanjer/julbord/') {
        return; // Avsluta scriptet direkt
    }

    let $html = $('html');
    let $flyout = $('.flyout[data-flyout="popup"]');

    if (!$flyout.length) {
        return;
    }

    function getCookie(name) {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    function setCookie(name, value, days = 1) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + ";path=/;expires=" + expires.toUTCString();
    }

    $(document).ready(function() {
        if (!getCookie('popup-showed')) {
            setTimeout(function() {
                $flyout.addClass('active');
                $html.addClass('flyout-open');
                $html.attr('data-flyout', 'popup');

                setCookie('popup-showed', 'true', 1);
            }, 1000);
        }
    });

}(jQuery));
//# sourceMappingURL=flyout-popup.js.map
